import {
  SeriesActionTypes,
  SET_ERROR,
  SET_SERIES,
  SET_SERIES_DETAILS,
  SET_SERIES_SUBMISSION_REPORTS,
  SET_SERIES_TRAINING_REPORTS,
  ADD_REPORT_AS_BEING_GENERATED,
  REMOVE_REPORT_AS_BEING_GENERATED,
  RESET_REPORTS_GENERATED_LIST,
  SET_ACTIVE_SERIES_IDS,
  SET_FUTURE_SERIES_IDS,
  GET_SERIES_DETAILS,
  SET_IS_LOADING,
  SET_SUBMISSION_REPORT_REQUEST_IS_LOADING,
  SET_SUBMISSION_REPORT_INDEX,
  SET_SUBMISSION_REPORT_HAS_LOADED,
  SET_SERIES_COMPONENTS_DATES,
} from './types';
import { RESET_GLOBAL_STATE, GlobalActionTypes } from '../types';
import { SeriesState } from '../../types/Series';
import { unknown } from '../actions';

const initialState: SeriesState = {
  seriesData: undefined,
  seriesDetails: undefined,
  submissionReports: undefined,
  trainingReports: undefined,
  reportsToGenerate: [],
  isLoading: true,
  hasError: false,
  activeSeriesIds: undefined,
  futureSeriesIds: [],
  isSubmissionReportRequestLoading: false,
  hasSubmissionReportRequestLoaded: false,
  submissionReportIndex: undefined,
  seriesComponentsDates: undefined,
};

export default (state = initialState, action: SeriesActionTypes | GlobalActionTypes = unknown()): SeriesState => {
  switch (action.type) {
    case SET_IS_LOADING: {
      const {
        payload: { value },
      } = action;

      return { ...state, isLoading: value };
    }

    case SET_SERIES_COMPONENTS_DATES: {
      const {
        payload: { seriesComponents },
      } = action;

      return {
        ...state,
        seriesComponentsDates: seriesComponents,
      };
    }

    case SET_SERIES: {
      const {
        payload: { seriesData },
      } = action;

      return {
        ...state,
        seriesData,
        isLoading: false,
        hasError: false,
      };
    }

    case SET_SERIES_DETAILS: {
      const {
        payload: { seriesDetails },
      } = action;

      return {
        ...state,
        seriesDetails,
        isLoading: false,
        hasError: false,
      };
    }
    case SET_SERIES_SUBMISSION_REPORTS: {
      const {
        payload: { submissionReports },
      } = action;

      return {
        ...state,
        submissionReports,
        isLoading: false,
      };
    }
    case SET_SERIES_TRAINING_REPORTS: {
      const {
        payload: { trainingReports },
      } = action;

      return {
        ...state,
        trainingReports,
        isLoading: false,
      };
    }
    case ADD_REPORT_AS_BEING_GENERATED: {
      const {
        payload: { index },
      } = action;

      return {
        ...state,
        reportsToGenerate: [...state.reportsToGenerate, index],
      };
    }
    case REMOVE_REPORT_AS_BEING_GENERATED: {
      const {
        payload: { index },
      } = action;
      const reportIndex = state.reportsToGenerate.findIndex((value) => value === index);
      const reportsToGenerate = [...state.reportsToGenerate];
      reportsToGenerate.splice(reportIndex, 1);

      return {
        ...state,
        reportsToGenerate,
      };
    }
    case RESET_REPORTS_GENERATED_LIST: {
      return {
        ...state,
        reportsToGenerate: [],
      };
    }
    case SET_ERROR: {
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };
    }
    case SET_ACTIVE_SERIES_IDS: {
      const {
        payload: { ids },
      } = action;

      return {
        ...state,
        activeSeriesIds: ids,
      };
    }
    case SET_FUTURE_SERIES_IDS: {
      const {
        payload: { ids },
      } = action;

      return {
        ...state,
        futureSeriesIds: ids,
      };
    }
    case GET_SERIES_DETAILS: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case SET_SUBMISSION_REPORT_REQUEST_IS_LOADING: {
      const {
        payload: { isLoading },
      } = action;

      return {
        ...state,
        isSubmissionReportRequestLoading: isLoading,
      };
    }
    case SET_SUBMISSION_REPORT_INDEX: {
      const {
        payload: { index },
      } = action;

      return {
        ...state,
        submissionReportIndex: index,
      };
    }
    case SET_SUBMISSION_REPORT_HAS_LOADED: {
      const {
        payload: { hasLoaded },
      } = action;

      return {
        ...state,
        hasSubmissionReportRequestLoaded: hasLoaded,
      };
    }
    case RESET_GLOBAL_STATE: {
      return initialState;
    }

    default:
      return state;
  }
};
